import { FC, useMemo, useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

import { DateRange, DateRangePicker } from '/shared/DateRangePicker';

import { IAttachmentsProps } from './types';
import { DialogContentStyled } from './styles';

export const AttachmentsDialog: FC<IAttachmentsProps> = ({ isOpen, range, onClick, onClose }) => {
  const [localRange, setLocalRange] = useState(range);
  const rangeMemo = useMemo<DateRange>(() => [localRange.from, localRange.to], [localRange.from, localRange.to]);

  const dropDateRange = (selectedRange: DateRange) => {
    setLocalRange((prev) => ({ ...prev, from: selectedRange[0] || range.from, to: selectedRange[1] || range.to }));
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        sx={{
          '& .MuiPaper-root': {
            overflow: 'visible',
          },
        }}
      >
        <DialogTitle>ReindexFor</DialogTitle>
        <DialogContentStyled>
          <DateRangePicker dateRange={rangeMemo} onDateRangeChange={dropDateRange} label='Time range' />
        </DialogContentStyled>
        <DialogActions>
          <Button onClick={() => onClick(localRange)}>ReindexFor</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
